import React from 'react';
import './Loader.css'; // Import the CSS for the animation

function Loader() {
  return (
    <div className="loader-overlay">
      <div className="rotating-gear"></div>
    </div>
  );
}

export default Loader;
